import { Component, OnInit, Output, Input } from '@angular/core';
import { EventEmitter } from 'events';

@Component({
  selector: 'app-consulta-cheque-sem-fundo',
  templateUrl: './consulta-cheque-sem-fundo.component.html',
  styleUrls: ['./consulta-cheque-sem-fundo.component.scss']
})
export class ConsultaChequeSemFundoComponent implements OnInit {

  @Input() consulta: any;
  @Input() titulo="";
  @Input() idConsulta="";
  @Input() tipoConsulta="";
  @Input() codigoControle="";
  @Output() update = new EventEmitter();

  statusMsg = null;
  status = 'info';

  msgNull = 'NÃO INFORMADO';

  constructor() { }

  ngOnInit() {}

  ngOnChanges() {
    if(this.consulta.registros && this.consulta.registros.length > 0) {
      this.status = 'warning';
      this.statusMsg = '';
    } else {
      this.status = 'success';
      this.statusMsg = 'NADA CONSTA';
    }
  }

}
